/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*!
 * enquire.js v2.1.6 - Awesome Media Queries in JavaScript
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT */

!function(a){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=a();else if("function"==typeof define&&define.amd)define([],a);else{var b;b="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,b.enquire=a()}}(function(){return function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a,b){this.query=a,this.isUnconditional=b,this.handlers=[],this.mql=window.matchMedia(a);var c=this;this.listener=function(a){c.mql=a.currentTarget||a,c.assess()},this.mql.addListener(this.listener)}var e=a(3),f=a(4).each;d.prototype={constuctor:d,addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var b=this.handlers;f(b,function(c,d){if(c.equals(a))return c.destroy(),!b.splice(d,1)})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){f(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";f(this.handlers,function(b){b[a]()})}},b.exports=d},{3:3,4:4}],2:[function(a,b,c){function d(){if(!window.matchMedia)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!window.matchMedia("only all").matches}var e=a(1),f=a(4),g=f.each,h=f.isFunction,i=f.isArray;d.prototype={constructor:d,register:function(a,b,c){var d=this.queries,f=c&&this.browserIsIncapable;return d[a]||(d[a]=new e(a,f)),h(b)&&(b={match:b}),i(b)||(b=[b]),g(b,function(b){h(b)&&(b={match:b}),d[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},b.exports=d},{1:1,4:4}],3:[function(a,b,c){function d(a){this.options=a,!a.deferSetup&&this.setup()}d.prototype={constructor:d,setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},b.exports=d},{}],4:[function(a,b,c){function d(a,b){var c=0,d=a.length;for(c;c<d&&b(a[c],c)!==!1;c++);}function e(a){return"[object Array]"===Object.prototype.toString.apply(a)}function f(a){return"function"==typeof a}b.exports={isFunction:f,isArray:e,each:d}},{}],5:[function(a,b,c){var d=a(2);b.exports=new d},{2:2}]},{},[5])(5)});


class ShippingDate extends HTMLElement{
  months = {
    0: 'January',
    1: 'February',
    2: 'March',
    3: 'April',
    4: 'May',
    5: 'June',
    6: 'July',
    7: 'August',
    8: 'September',
    9: 'October',
    10: 'November',
    11: 'December'
  }

  daysOfWeek = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday'
  }

  constructor(){
    super();
    this.num = this.getElementsByClassName("num")[0].value;
    this.before_eta_message = this.getElementsByClassName("before-eta-message")[0];
    let shippingDate = this.addWorkDays(new Date());

    //this.before_eta_message.append(this.createTextNode(shippingDate));
    this.querySelector('.eta-date').append(this.createTextNode(shippingDate));
    this.classList.add("done");
  }

  createTextNode(text){
    let textNode = document.createElement("span");
    textNode.innerText = text;
    textNode.classList.add("text");
    return textNode;
  }

  addWorkDays(startDate) {
    if(isNaN(this.num)) {
        console.log("Value provided for \"days\" was not a number");
        return
    }
    if(!(startDate instanceof Date)) {
        console.log("Value provided for \"startDate\" was not a Date object");
        return
    }
    // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
    var dow = startDate.getDay();
    var daysToAdd = parseInt(this.num);
    // If the current day is Sunday add one day
    if (dow == 0)
        daysToAdd++;
    // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
    if (dow + daysToAdd >= 6) {
        //Subtract days in current working week from work days
        var remainingWorkDays = daysToAdd - (5 - dow);
        //Add current working week's weekend
        daysToAdd += 2;
        if (remainingWorkDays > 5) {
            //Add two days for each working week by calculating how many weeks are included
            daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
            //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks
            if (remainingWorkDays % 5 == 0)
                daysToAdd -= 2;
        }
    }
    startDate.setDate(startDate.getDate() + daysToAdd);
    return this.daysOfWeek[startDate.getDay()] + ", " + startDate.getDate() + " " + this.months[startDate.getMonth()];
  }
}

customElements.define("shipping-date", ShippingDate);


class FeaturedCollections extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll('.featured-collection__tab');
    this.panels = this.querySelectorAll('.featured-collection__panel');

    Array.from(this.buttons).forEach(function(btn){
      btn.addEventListener('click', this.switchTab.bind(this));
    }, this);
  }

  switchTab (e) {
    e.preventDefault();
    let tab_index = e.target.dataset.index;
    Array.from(this.buttons).forEach(function(btn){
      if(btn.dataset.index != tab_index) {
        btn.classList.remove('active');
      }else {
        btn.classList.add('active');
      }
    }, this);
    Array.from(this.panels).forEach(function(panel){
      if(panel.dataset.index != tab_index) {
        panel.classList.remove('active');
      }else {
        panel.classList.add('active');
      }
    }, this);
  }
}

customElements.define('featured-collections', FeaturedCollections);

class Behaviour extends HTMLElement {
  constructor() {
      super();

      this.mouseDown = false;
      this.hasDragged = false;
      this.startX = 0;
      this.scrollLeft = 0;

      this.container = this.querySelector('.behaviour-container');
      this.list = this.querySelector('.behaviour-list');

      this.list.addEventListener('mousemove', this.move.bind(this));
      this.list.addEventListener('mousedown', this.startDragging.bind(this));
      this.list.addEventListener('mouseup', this.stopDragging.bind(this));
      this.list.addEventListener('mouseleave', this.stopDragging.bind(this));

      this.links = this.list.querySelectorAll('.behaviour-link');

      // Ensure links are enabled on page load
      this.linksHandler('enable');

      this.checkLinkActive();

      this.buttons = this.querySelectorAll('.behaviour-scrollable');
      Array.from(this.buttons).forEach(function(button){
          button.addEventListener('click', this.scrollable.bind(this));
      }, this);

      this.showMore = this.querySelector('.behaviour-showmore');
      this.showMore.addEventListener('click', this.toggleShowMore.bind(this));

      document.addEventListener('theme:loading:end', function(){
        this.checkChangeTag();
      }.bind(this));
  }
  checkChangeTag() {
    let inputFilters = document.querySelector('.collection__filter-collapsible[data-group="behaviour"] .checkbox');

    Array.from(inputFilters).forEach(function(input){
      let tagActive = '';
      if(input.checked) {
        tagActive = input.dataset.tag;
      }
      if(tagActive != '') {
        Array.from(this.links).forEach(function(link){
          let linkTagName = link.dataset.tag;
          let parentE = link.parentElement;
          if(linkTagName == tagActive) {
            parentE.classList.add('active');
          }else {
            parentE.classList.remove('active');
          }
        }, this);
      }
      
    }, this);
  }
  checkLinkActive() {
      // scroll to first link active - use instant scroll on page load to avoid layout shift
      let has_link_active = false;
      Array.from(this.links).forEach(function(link){
          let parentE = link.parentElement;
          if(parentE.classList.contains('active') && parentE.offsetLeft > this.container.offsetLeft && !has_link_active) {
              this.list.scrollBy({left: link.offsetLeft - 35, behavior: 'auto'});
              has_link_active = true;
          }
      }, this);
  }
  scrollable(e) {
      e.preventDefault();
      let scroll = 0;
      let move = e.target.closest('a').dataset.move;
      
      if(move == 'prev') {
          scroll = -200;
      }else {
          scroll = +200;
      }
      this.list.scrollBy({left: scroll, behavior: 'smooth'});
  }
  startDragging = (e) => {
      // Only disable links after user actually starts dragging (not just mousedown)
      this.dragStartTime = Date.now();
      this.startX = e.pageX - this.list.offsetLeft;
      this.scrollLeft = this.list.scrollLeft;
      this.hasDragged = false;
  }

  stopDragging = (e) => {
      // Only keep links disabled if user actually dragged (not just clicked)
      if (this.hasDragged) {
          this.mouseDown = false;
          // Brief delay to prevent accidental clicks after drag
          setTimeout(() => {
              this.linksHandler('enable');
          }, 100);
      } else {
          this.mouseDown = false;
          this.linksHandler('enable');
      }
  }
    
  move = (e) => {
      e.preventDefault();
      if(!this.mouseDown) { return; }
      const x = e.pageX - this.list.offsetLeft;
      const scroll = x - this.startX;

      // If user has moved more than 5px, consider it a drag and disable links
      if (Math.abs(scroll) > 5 && !this.hasDragged) {
          this.hasDragged = true;
          this.mouseDown = true;
          this.linksHandler('disable');
      }

      if (this.hasDragged) {
          this.list.scrollLeft = this.scrollLeft - scroll;
      }
  }

  linksHandler(action) {
      Array.from(this.links).forEach(function(link){
          if(action == 'disable') {
              link.parentElement.classList.add('disable');
          }else {
              link.parentElement.classList.remove('disable');
          }
      }, this)
  }

  toggleShowMore(e) {
      e.preventDefault();
      if(this.list.classList.contains('show-all')) {
          this.list.classList.remove('show-all');
      }else {
          this.list.classList.add('show-all');
      }
  }
}

customElements.define('behaviour-element', Behaviour);

/*============================================================================
  CountdownTimer
==============================================================================*/

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.display = this.querySelector('[data-time-display]');
    this.block = this.closest('.countdown__block--timer');
    this.year = this.el.dataset.year;
    this.month = this.el.dataset.month;
    this.day = this.el.dataset.day;
    this.hour = this.el.dataset.hour;
    this.minute = this.el.dataset.minute;
    this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
    this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
    this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
    this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
    this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
    this.hideTimerOnComplete = this.el.dataset.hideTimer;
    this.completeMessage = this.el.dataset.completeMessage;

    this.timerComplete = false;

    this.init();
  }

  init() {
    setInterval(() => {
      if (!this.timerComplete) {
        this._calculate();
      }
    }, 1000);

  }

  _calculate() {
    // Find time difference and convert to integer
    const targetDate = new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`);
    const timeDifference = this._getAESTTimeDifference(targetDate);

    // If time difference is greater than 0, calculate remaining time
    if (timeDifference > 0) {
      const intervals = {
        days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((timeDifference / 1000 / 60) % 60),
        seconds: Math.floor((timeDifference / 1000) % 60),
      };

      this.daysPlaceholder.innerHTML = intervals.days;
      this.hoursPlaceholder.innerHTML = intervals.hours;
      this.minutesPlaceholder.innerHTML = intervals.minutes;
      this.secondsPlaceholder.innerHTML = intervals.seconds;

      setTimeout(() => {
        this.display.classList.add('countdown__display--loaded');
      }, 1);
    } else {
      if (this.completeMessage && this.messagePlaceholder) {
        this.messagePlaceholder.classList.add('countdown__timer-message--visible');
      }

      if (this.hideTimerOnComplete === 'true') {
        this.display.classList.remove('countdown__display--visible');
        this.display.classList.add('countdown__display--hidden');
      }

      if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
        this.block.classList.add('countdown__block--hidden');
      }

      this.timerComplete = true;
    }
  }

  _getAESTTimeDifference(targetDate) {
    const awstOffset = 8 * 60; // AWST is UTC+8
    const currentDate = new Date();
    const currentUTCDate = new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60000);
    const targetUTCDate = new Date(targetDate.getTime() - awstOffset * 60000);
    return targetUTCDate - currentUTCDate;
  }
}

customElements.define('countdown-timer', CountdownTimer);


window.scope = window.scope || {};
scope.bp = {
  smallUp: 769,
  small: 768
};

scope.config = {
  mediaQuerySmall: 'screen and (max-width: ' + scope.bp.small + 'px)',
  mediaQuerySmallUp: 'screen and (min-width: ' + scope.bp.smallUp + 'px)'
};

scope.init = function () {

  let checkJQueryInterval = setInterval(() => {
    if(window.jQuery) {
      scope.mobileSearch();
      scope.initYoutubeVideoMockups();
      // scope.checkProductInfoHeight();
      scope.formNameFieldSplitter();
      scope.aetertekTemplateInit();
      scope.initConfig();
      scope.cartCouponAction();
      scope.showHeaderStickyIfScrollUp();
      scope.closeCollectionSolutionByType();
      scope.showReviewPopupWhenClickReviewBullet();
      scope.customMegaMenuHover();
      scope.copyToclipboard();
      clearInterval(checkJQueryInterval);
    }
  }, 300);

  

  // Array.from(document.getElementsByClassName("mega-menu__title js-click-trigger")).forEach( ( $megaMenuItem ) => {
  //   $megaMenuItem.addEventListener("click", scope.megaSubMenu1ClickTrigger);
  // })
  // Array.from(document.getElementsByClassName("mega-menu__link js-click-trigger")).forEach( ( $megaMenuItem ) => {
  //   $megaMenuItem.addEventListener("click", scope.megaSubMenu2ClickTrigger);
  // })

  Array.from(document.getElementsByClassName("scroll-anchor")).forEach((e) => {
    e.addEventListener("click", this.scrollAnchor);
  })

}

scope.mobileSearch = () => {
  
  jQuery('[data-action="toggle-search"]').off( "click" );

  jQuery(document).on('click', '[data-action="toggle-search"]', function(e) {
    e.preventDefault();

    jQuery('.header').addClass('header--search-expanded');
    jQuery('.header__search-bar-mobile').addClass('is-visible');

  });

  jQuery(document).on('click', '.search-bar-mobile__close-button, .search-bar__close-button', function(e) {
    e.preventDefault();
    e.stopPropagation();

    if( jQuery('.header').hasClass('header--search-expanded') && jQuery('.header__search-bar-mobile').hasClass('is-visible') ) {
      jQuery('.header').removeClass('header--search-expanded');
      jQuery('.header__search-bar-mobile').removeClass('is-visible is-fixed');
    }
  });
}

scope.megaSubMenu1ClickTrigger = (e) => {
  e.preventDefault();

  const menuWrapper = e.target.parentNode;
  
  if(! menuWrapper.classList.contains("active")){
    Array.from(menuWrapper.parentNode.getElementsByClassName("mega-menu__column active")).forEach(($activeMenu) => {
      $activeMenu.classList.remove("active");
    });
    Array.from(menuWrapper.parentNode.getElementsByClassName("mega-menu__item active")).forEach(($activeMenu) => {
      $activeMenu.classList.remove("active");
    });

    menuWrapper.classList.add("active");
  }
  else{
    window.location.href = e.target.href;
  }

  return false;
}

scope.megaSubMenu2ClickTrigger = (e) => {
  e.preventDefault();

  const menuWrapper = e.target.parentNode;

  if(! menuWrapper.classList.contains("active")){
    Array.from(menuWrapper.parentNode.getElementsByClassName("mega-menu__item active")).forEach(($activeMenu) => {
      $activeMenu.classList.remove("active");
    })
    menuWrapper.classList.add("active");
  }
  else{
    window.location.href = e.target.href;
  }

  return false;
}

scope.megaMenuCloseTrigger = (e) => {
  // e.preventDefault();

  const menuWrapper = e.target.parentNode.parentNode;

  Array.from(menuWrapper.getElementsByClassName("mega-menu__column active")).forEach(($activeMenu) => {
    $activeMenu.classList.remove("active");
  })

  // return false;
}
scope.customMegaMenuHover = function() {
  let mega_items = document.querySelectorAll('.nav-bar__item.shop-by .mega-menu__link');
  let panels = document.querySelectorAll('.nav-panel');
  Array.from(mega_items).forEach(function(item){
    item.addEventListener('mouseover', function(e){
      let menu_link = e.currentTarget.hash;
      let menu_handle = menu_link.replace('#', '');


      e.target.classList.add('on-hover');

      
      Array.from(panels).forEach(function(panel, index){
        if(panel.classList.contains('nav-panel--' + menu_handle)){
          panel.classList.add('active');
        }else {
          panel.classList.remove('active');
          mega_items[index].classList.remove('on-hover');
        }
      });
    });
  });

  document.addEventListener('click', function(e){
    if(!e.target.closest('.nav-bar__item.shop-by')) {
      Array.from(panels).forEach(function(panel){
        panel.classList.remove('active');
      });
    }
    
    if(e.target.parentElement.classList.contains('mega-menu') && e.target.closest('.shop-by')) {
      let parent = e.target.parentElement;
      parent.parentElement.querySelector('.nav-bar__link').click();
    }
  });
}
scope.initConfig = function () {
  enquire.register(scope.config.mediaQuerySmall, {
    match: function () {
      scope.config.bpSmall = true;
      
      document.body.dispatchEvent(new Event('matchSmall'));
    },
    unmatch: function () {
      scope.config.bpSmall = false;
      document.body.dispatchEvent( new Event('unmatchSmall'));
    }
  });

  enquire.register(scope.config.mediaQuerySmallUp, {
    match: function() {
      document.body.dispatchEvent( new Event('matchLarge'));
    },
    unmatch: function() {
      document.body.dispatchEvent( new Event('unmatchLarge'));
    }
  });
};

scope.checkProductInfoHeight = function () {
  var galleryHeight = parseInt(jQuery(".product-block-list__item--gallery .card").height());
  var infoHeight = parseInt(jQuery(".product-block-list__item--info .card").height());

  var maxHeight = galleryHeight > infoHeight ? galleryHeight : infoHeight;

  jQuery(".product-block-list__item--gallery .card, .product-block-list__item--info .card").height(maxHeight);
};

scope.initYoutubeVideoMockups = function () {
  var $youtubeMockup = document.getElementsByClassName("youtube-video");

  if ($youtubeMockup.length > 0) {

    for (var i = $youtubeMockup.length - 1; i >= 0; i--) {
      scope.checkYoutubeVideoMockup($youtubeMockup[i]);
    }

    window.addEventListener("scroll", function () {
      for (var i = $youtubeMockup.length - 1; i >= 0; i--) {
        scope.checkYoutubeVideoMockup($youtubeMockup[i]);
      }
    });

  }
};

scope.checkYoutubeVideoMockup = function($mockup) {
  if ((!$mockup.classList.contains("video-wrapper")) && scope.checkScreenBoundedElement($mockup, 200)) {
    var url = $mockup.dataset.url;
    var youtubeID = scope.getYoutubeIDFromUrl(url);

    if (youtubeID) {
      var embedCode = scope.createYoutubeEmbedVideo(youtubeID);

      $mockup.innerHTML = embedCode;
      $mockup.classList.add("video-wrapper");
    }
  }
};

scope.getYoutubeIDFromUrl = function (url) {

  if (url != undefined || url != '') {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
    var match = url.match(regExp);
    if (match && match[2].length == 11) {
      return match[2];
    }
  }

  return false;
};

scope.createYoutubeEmbedVideo = function (youtubeID) {
  var embedURL = 'https://www.youtube.com/embed/' + youtubeID;

  return '<iframe src="' + embedURL + '" allowfullscreen="" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>';
};

scope.checkScreenBoundedElement = function ($el, offset) {

  if (typeof offset == undefined) {
    offset = 0
  }

  var windowTop = window.scrollY;
  var elOffsetTop = $el.offsetTop;
  var windowHeight = window.innerHeight;

  return (elOffsetTop + offset) <= (windowTop + windowHeight);
};

scope.formNameFieldSplitter = function () {
  if (document.querySelectorAll(".form__input-wrapper--name").length > 0) {
    var $fullNameInputs = document.querySelectorAll(".form__input-wrapper--name .full_name");

    $fullNameInputs.forEach(function ($input) {
      $input.addEventListener("blur", function () {
        var fullNameParts = this.value.split(" ");
        var firstName = fullNameParts.shift();
        var lastName = fullNameParts.join(" ");

        this.parentNode.querySelector(".first_name").value = firstName;
        this.parentNode.querySelector(".last_name").value = lastName;
      });
    });

  }
};

scope.aetertekTemplateInit = function () {

  if (document.body.classList.contains("page-brand-aetertek")) {
    // JudgeMe review functions removed - now using Loox
    // TODO: Add Loox widgets to Aetertek brand pages if needed
  }
};

scope.cartCouponAction = function(){
  if(document.body.classList.contains("cart")){
    var couponAppliers = document.querySelectorAll("[data-action='coupon-code']");

    couponAppliers.forEach(function ($button) {
      $button.addEventListener("click", function (event) {
        event.preventDefault();
        //write the url format
        var theUrl = '/checkout?discount=';
        //grab the discount code from the input
        var theDiscount = document.getElementById("coupon-code__code").value;
        //full url to redirect to checkout with promo code
        var toRedirect = theUrl+theDiscount;
        console.log(toRedirect);
        //redirect
        window.location.href = toRedirect;
      });
    });

  }
};

scope.scrollAnchor = (e) => {
  // e.preventDefault();
  let anchorID = e.currentTarget.attributes.href.nodeValue;

  if(anchorID.indexOf("#") > -1){
    anchorID = anchorID.replaceAll("#", "");
  }

  const anchorElement = document.getElementById(anchorID);

  if(anchorElement != null){
    const anchorOffsetTop = anchorElement.getBoundingClientRect().top + window.scrollY;;
    const headerOffset = 144;
    let anchorOffset = anchorOffsetTop - headerOffset;
    
    window.scroll({
      x: 0,
      y: anchorOffset,
      behavior: 'smooth'
    })
  }
  // return false;
};

scope.showHeaderStickyIfScrollUp = function () {
  let offset = newValue = oldValue = 0;
  let header = document.getElementById("shopify-section-header");
  let topline = document.getElementById("shopify-section-announcement-bar");
  let shipping_threshold = document.getElementById("shopify-section-shipping-threshold");
  let popups = document.getElementById("shopify-section-popups");

  let headerBottomOffset = 0;
  let toplineBottomOffset = 0;

  // // add action if template is collection
  let collection_filter = document.getElementsByClassName("collection__toolbar")[0];
  
  // // add action if template is collection
  let product_info = document.querySelector(".product-block-list__right-inner");
  
  // mini cart
  let mini_cart = document.getElementsByClassName('mini-cart')[0];

  let section = header.querySelector('section');
  let section_settings = JSON.parse(section.getAttribute('data-section-settings'));
  
  if(section_settings.useStickyHeader != undefined && section_settings.useStickyHeader) {
    window.addEventListener('scroll', function(e){
      if(topline == '' || topline == null) {
        headerBottomOffset = header.offsetHeight;
      }else{
        headerBottomOffset = topline.offsetHeight + header.offsetHeight;
      } 
  
      if(shipping_threshold == '' || shipping_threshold == null) {
        headerBottomOffset = headerBottomOffset;
      }else {
        headerBottomOffset = headerBottomOffset + shipping_threshold.offsetHeight;
      }

      if(popups == '' || popups == null) {
        headerBottomOffset = headerBottomOffset;
      }else {
        headerBottomOffset = headerBottomOffset + popups.offsetHeight;
      }
      // Get the new Value
      newValue = window.pageYOffset;
      offset = newValue - oldValue;
      if(newValue > headerBottomOffset && !header.classList.contains('sticky')) {
        header.classList.add('sticky');
        header.classList.add('hide-header');
        mini_cart.classList.add('hide-header');
        if(collection_filter != undefined) {
          collection_filter.classList.remove("has-header");
        }
        if(product_info != undefined) {
          product_info.classList.remove("has-header");
        }
  
      } else if (newValue <= toplineBottomOffset && header.classList.contains('sticky')){
        header.classList.remove('sticky');
        header.classList.remove('header-animate');
        if(collection_filter != undefined) {
          collection_filter.classList.remove("has-header");
        }
        if(product_info != undefined) {
          product_info.classList.remove("has-header");
        }
      }
      //Subtract the two and conclude
      if(offset > 0 && !header.classList.contains('hide-header') && newValue > headerBottomOffset){
        header.classList.add('hide-header');
        mini_cart.classList.add('hide-header');
        
        if(collection_filter != undefined) {
          collection_filter.classList.remove("has-header");
        }
        if(product_info != undefined) {
          product_info.classList.remove("has-header");
        }

      } else if (offset < 0 && header.classList.contains('hide-header')){
        header.classList.remove('hide-header');
        mini_cart.classList.remove('hide-header');
        header.classList.add('header-animate');
        
        if(collection_filter != undefined) {
          collection_filter.classList.add("has-header");
        }

        if(product_info != undefined) {
          product_info.classList.add("has-header");
        }
        
      }
      // Update the old value
      oldValue = newValue;
    });
  }
};

scope.closeCollectionSolutionByType = function() {
  // Get all elements with class "collection-type-item__close"
  const closeButtons = document.querySelectorAll('.collection-type-item__close');

  // Add click event listener to each close button
  closeButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      // Prevent the default behavior of the link
      event.preventDefault();

      // Get the URL to navigate back to
      const backUrl = document.querySelector('.collection-type-list').dataset.parentUrl;

      // Check if the button has a parent anchor element
      if (button.parentElement && button.parentElement.querySelector('.collection-type-item__block')) {
        // Get the href attribute from the parent anchor element
        var blockLink = button.parentElement.querySelector('.collection-type-item__block').getAttribute('href');

        // Update the backUrl if a valid href is found
        if (blockLink && blockLink !== '#') {
          backUrl = blockLink;
        }
      }

      // Navigate back to the specified URL
      if( backUrl ) {
        window.location.href = backUrl;
      }
    });
  });
};

scope.showReviewPopupWhenClickReviewBullet = function() {
  
  let reviewBullet = document.querySelector('.section__review-info');
  if(reviewBullet != null) {
    reviewBullet.addEventListener('click', function(){
      let reviewBtn = document.querySelector('.loox-floating-widget-btn');
      if(reviewBtn != null) {
        reviewBtn.click();
      }
    });
  }
}

// Copy coupon to clipboard
scope.copyToclipboard = function() {
  function changeTextToCopied(text, button) {
    navigator.clipboard.writeText(text).then(() => {
      const copyButtonText = button.innerHTML;
      button.innerHTML = 'copied';

      setTimeout(() => {
        button.innerHTML = copyButtonText;
      }, 1000);
    }).catch(err => {
      console.error('Error copying text: ', err);
    });
  }

  // Copy to clipboard for the coupon
  const couponButtons = document.querySelectorAll('.coupon-code-btn');
  couponButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.stopPropagation();

      let textToCopy = '';
      const couponCode = this;

      if( couponCode ) {
        textToCopy = couponCode.innerText;
      }
      console.log(textToCopy);
      if (textToCopy) {
        changeTextToCopied(textToCopy, this);
      }
    });
  });
}


if (
  document.readyState === "complete" ||
  (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
  scope.init();
  
} else {
  document.addEventListener("DOMContentLoaded", function () { scope.init(); });
}



